import React from 'react';
import { FiHome, FiPlayCircle, FiSend, FiTrendingUp } from 'react-icons/fi';
import { PROFILE_AVATAR } from './ProfileHeader';
import { initialOf } from './TopBar';

const BottomNav = ({ active, user, onHome, onSelect, onMessage, onProfile }) => (
    <nav className="ig-bottomnav" aria-label="Main">
        <button type="button" className={active === 'posts' ? 'is-active' : ''} onClick={onHome} aria-label="Home">
            <FiHome aria-hidden="true" />
        </button>
        <button type="button" className={active === 'top' ? 'is-active' : ''} onClick={() => onSelect('top')} aria-label="Top posts">
            <FiTrendingUp aria-hidden="true" />
        </button>
        <button type="button" className={active === 'viewed' ? 'is-active' : ''} onClick={() => onSelect('viewed')} aria-label="Most viewed">
            <FiPlayCircle aria-hidden="true" />
        </button>
        <button type="button" onClick={onMessage} aria-label="Message support">
            <FiSend aria-hidden="true" />
        </button>
        <button
            type="button"
            className={`ig-bottomnav-profile${active === 'saved' ? ' is-active' : ''}`}
            onClick={onProfile}
            aria-label={user ? 'Saved posts' : 'Log in'}
        >
            {user
                ? <span className="ig-user-chip ig-user-chip--sm" aria-hidden="true">{initialOf(user)}</span>
                : <img src={PROFILE_AVATAR} alt="" width="26" height="26" />}
        </button>
    </nav>
);

export default BottomNav;
